module.exports = __webpack_public_path__ + "img/flights-zh-img.59cd7450.png";